import {
  GetDocuementsQueryParams,
  GetDocuementsResponse,
  SearchProductsFiltersApplicationsQueryParams,
  SearchProductsFiltersClassificationsQueryParams,
  SearchProductsFiltersClonalitiesQueryParams,
  SearchProductsFiltersConjugateQueryParams,
  SearchProductsFiltersHostSpeciesQueryParams,
  SearchProductsFiltersIsotypesQueryParams,
  SearchProductsFiltersReactivitiesQueryParams,
  SearchProductsFiltersResponse,
  SearchProductsFiltersSuppliersQueryParams,
  SearchProductsFiltersTargetsQueryParams,
  SearchProductsQueryParams,
  SearchProductsResponse,
} from '@interfaces/products.interface';

import api from './';

export const {
  useSearchProductsQuery,
  useLazyGetDocumentsQuery,
  useLazySearchProductsFiltersTargetsQuery,
  useLazySearchProductsFiltersReactivitiesQuery,
  useLazySearchProductsFiltersHostSpeciesQuery,
  useLazySearchProductsFiltersConjugateQuery,
  useLazySearchProductsFiltersClonalitiesQuery,
  useLazySearchProductsFiltersIsotypesQuery,
  useLazySearchProductsFiltersClassificationsQuery,
  useLazySearchProductsFiltersApplicationsQuery,
  useLazySearchProductsFiltersSuppliersQuery,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    searchProducts: builder.query<
      SearchProductsResponse,
      SearchProductsQueryParams
    >({
      query: (params) => ({
        url: 'products/search',
        method: 'GET',
        params,
      }),
    }),

    searchProductsFiltersTargets: builder.query<
      SearchProductsFiltersResponse[],
      SearchProductsFiltersTargetsQueryParams
    >({
      query: (params) => ({
        url: 'products/search/filters/targets',
        method: 'GET',
        params,
      }),
    }),
    searchProductsFiltersReactivities: builder.query<
      SearchProductsFiltersResponse[],
      SearchProductsFiltersReactivitiesQueryParams
    >({
      query: (params) => ({
        url: 'products/search/filters/reactivities',
        method: 'GET',
        params,
      }),
    }),
    searchProductsFiltersHostSpecies: builder.query<
      SearchProductsFiltersResponse[],
      SearchProductsFiltersHostSpeciesQueryParams
    >({
      query: (params) => ({
        url: 'products/search/filters/hostSpecies',
        method: 'GET',
        params,
      }),
    }),
    searchProductsFiltersConjugate: builder.query<
      SearchProductsFiltersResponse[],
      SearchProductsFiltersConjugateQueryParams
    >({
      query: (params) => ({
        url: 'products/search/filters/conjugate',
        method: 'GET',
        params,
      }),
    }),
    searchProductsFiltersClonalities: builder.query<
      SearchProductsFiltersResponse[],
      SearchProductsFiltersClonalitiesQueryParams
    >({
      query: (params) => ({
        url: 'products/search/filters/clonalities',
        method: 'GET',
        params,
      }),
    }),
    searchProductsFiltersIsotypes: builder.query<
      SearchProductsFiltersResponse[],
      SearchProductsFiltersIsotypesQueryParams
    >({
      query: (params) => ({
        url: 'products/search/filters/isotypes',
        method: 'GET',
        params,
      }),
    }),
    searchProductsFiltersClassifications: builder.query<
      SearchProductsFiltersResponse[],
      SearchProductsFiltersClassificationsQueryParams
    >({
      query: (params) => ({
        url: 'products/search/filters/classifications',
        method: 'GET',
        params,
      }),
    }),
    searchProductsFiltersApplications: builder.query<
      SearchProductsFiltersResponse[],
      SearchProductsFiltersApplicationsQueryParams
    >({
      query: (params) => ({
        url: 'products/search/filters/applications',
        method: 'GET',
        params,
      }),
    }),
    searchProductsFiltersSuppliers: builder.query<
      SearchProductsFiltersResponse[],
      SearchProductsFiltersSuppliersQueryParams
    >({
      query: (params) => ({
        url: 'products/search/filters/suppliers',
        method: 'GET',
        params,
      }),
    }),
    getDocuments: builder.query<
      GetDocuementsResponse[],
      GetDocuementsQueryParams
    >({
      query: ({ id }) => ({
        url: `products/documents/${id}`,
        cache: 'no-cache',
      }),
    }),
  }),
});
